import { IDataShape } from '../models/dataShape'
import { ITreeStructure } from '../models/treeStructure'

export interface IOptions<T extends IDataShape> {
  itemCaption: keyof T
}

export const mapDataShapeToTreeStructure = <T extends IDataShape>(
  data: T[],
  options: IOptions<T>
): ITreeStructure[] => {
  return data.map((it) => ({
    ...it,
    nestedItems: [],
    parent: null,
    hasChildren: false,
    checkedState: 'empty',
    title: it[options.itemCaption],
  }))
}
